// One visual language for every floating panel (tooltips, popovers, menus):
// subtle theme border, page background, prominent shadow. Interaction models
// differ per component; the look must not.
export const FLOATING_PANEL_CLS = "rounded-lg border border-border bg-background shadow-lg";
